import React from 'react';
import Reveal from '../ui/Reveal';
import SpotCard from './SpotCard';
import { nextSteps } from '../../data/masterclass';

const NextStepsSection: React.FC = () => {
  return (
    <section className="relative overflow-hidden py-24 md:py-28">
      <img
        src="/images/06-masterclass/masterclass-9.jpeg"
        alt=""
        aria-hidden="true"
        loading="lazy"
        className="pointer-events-none absolute inset-0 h-full w-full animate-kenburns object-cover opacity-[0.14]"
      />
      <div
        className="pointer-events-none absolute inset-0"
        style={{ background: 'linear-gradient(180deg, rgba(7,12,36,.86), rgba(9,15,48,.9))' }}
      />
      <div className="relative mx-auto max-w-7xl px-5">
        <Reveal className="max-w-2xl">
          <div className="mb-4 flex items-center gap-3">
            <span className="text-sm text-white/30">07</span>
            <span className="eyebrow-mc text-mc-electric/90">Después de registrarte</span>
          </div>
          <h2 className="font-display text-3xl font-bold leading-[1.1] md:text-5xl">
            Tu registro está a solo <span className="text-gradient-mc">3 pasos</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-5 md:grid-cols-3">
          {nextSteps.map((step, index) => (
            <Reveal key={step.number} delay={index * 80}>
              <SpotCard className="h-full rounded-[22px] border border-white/10 bg-white/5 p-7 backdrop-blur-md">
                <div className="flex items-center gap-3">
                  <div className="grid h-11 w-11 place-items-center rounded-full bg-mc-gradient font-display font-extrabold text-white">
                    {step.number}
                  </div>
                  <span className="text-sm text-white/25">{step.label}</span>
                </div>
                <h3 className="mt-4 font-display text-lg font-bold">{step.title}</h3>
                <p className="mt-2 text-sm font-light text-white/60">{step.description}</p>
              </SpotCard>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NextStepsSection;
